// src/oneSignalConfig.js
import OneSignal from 'react-onesignal';

const initializeOneSignal = async () => {
  try {
    // Check if we're in browser environment
    if (typeof window === 'undefined') {
      console.log('OneSignal: Not in browser environment');
      return;
    }

    // Check if OneSignal is already initialized
    if (window.OneSignal) {
      console.log('OneSignal already initialized');
      return;
    }

    // Check if service workers are supported
    if (!('serviceWorker' in navigator)) {
      console.warn('Service Workers are not supported');
      return;
    }

    console.log('Initializing OneSignal...');
    
    await OneSignal.init({
      appId: '5013f897-6d98-4c5f-bb14-7f5561ddc195',
      allowLocalhostAsSecureOrigin: true,
      
      // Service Worker paths
      serviceWorkerPath: '/OneSignalSDKWorker.js',
      serviceWorkerUpdaterPath: '/OneSignalSDKUpdaterWorker.js',
      
      // Notification button
      notifyButton: {
        enable: true,
        size: 'medium',
        theme: 'default',
        position: 'bottom-right',
        showCredit: false,
      },
      
      // Welcome notification
      welcomeNotification: {
        disable: false,
        title: 'Welcome to FinMaster!',
        message: 'Thanks for subscribing! Stay updated with financial tips.',
      },
      
      // Auto register
      autoRegister: true,
      
      // Error handling
      errorCallback: (error) => {
        console.error('OneSignal Error:', error);
      }
    });

    console.log('OneSignal initialized successfully');

    // Show prompt after initialization
    setTimeout(() => {
      try {
        if (OneSignal.Slidedown && OneSignal.Slidedown.promptPush) {
          console.log('Showing OneSignal prompt');
          OneSignal.Slidedown.promptPush();
        } else if (OneSignal.showSlidedownPrompt) {
          OneSignal.showSlidedownPrompt();
        }
      } catch (error) {
        console.error('Error showing OneSignal prompt:', error);
      }
    }, 2000);

  } catch (error) {
    console.error('OneSignal initialization failed:', error);
  }
};

export default initializeOneSignal;
// import OneSignal from 'react-onesignal';

// const initializeOneSignal = async () => {
//   await OneSignal.init({
//     appId: '5013f897-6d98-4c5f-bb14-7f5561ddc195',
//     allowLocalhostAsSecureOrigin: true, // If you are testing on localhost
//     notifyButton: {
//       enable: true,
//     },
//   });
//   // Correct way to show the prompt
//   OneSignal.Slidedown.promptPush();
//   // OneSignal.showSlidedownPrompt();
// };

// export default initializeOneSignal;


// import OneSignal from 'react-onesignal';

// const initializeOneSignal = async () => {
//   try {
//     await OneSignal.init({
//       appId: '5013f897-6d98-4c5f-bb14-7f5561ddc195', // Replace with your actual OneSignal app ID
//       allowLocalhostAsSecureOrigin: true, // If you are testing on localhost
//       notifyButton: {
//         enable: true,
//       },
//     });

//     // Ensure OneSignal is initialized before calling showSlidedownPrompt
//     const isPushNotificationsEnabled = await OneSignal.isPushNotificationsEnabled();

//     if (!isPushNotificationsEnabled) {
//       OneSignal.showSlidedownPrompt().catch((error) => {
//         console.error('Error showing slide down prompt:', error);
//       });
//     }

//     OneSignal.on('subscriptionChange', function (isSubscribed) {
//       if (!isSubscribed) {
//         OneSignal.showSlidedownPrompt().catch((error) => {
//           console.error('Error showing slide down prompt:', error);
//         });
//       }
//     });
//   } catch (error) {
//     console.error('OneSignal initialization error:', error);
//   }
// };
// export default initializeOneSignal;


